<template>
    <div>
        <template v-if="aiRules.length>0">
            <template v-for="(ele, i) in aiRules" >
                <ai-readable-chips 
                    :key="i" 
                    :filterObject="ele"
                    :conditionText="conditionText ? 'AND' : 'OR'"
                    :filterIndex="i"
                    :aiRules = "aiRules"
                >
                </ai-readable-chips>
            </template> 
        </template>
    </div>
</template>

<script>
import aiReadableChips from './readableChips.vue'
import rulesCondition from '../RulesCondition.vue'
export default{
    name: 'aiRulePreview',
    components:{
            aiReadableChips,
            rulesCondition
        },
    props :{
        aiRules :{
            type: Array,
            default : () => ([])
        },
        conditionText:{
            type: Boolean,
            default : () => false
        }
    },

}
</script>